<div class="page-body">
  <div *ngIf="error" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">Etwas ist schief gelaufen.</p>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>

      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          class="button-width"
          (click)="handleCtaClick()"
          [text]="'Erneut versuchen'"
          [rounded]="true"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>

  <div *ngIf="loading && !error">
    <app-spinner [infoText]="'Zahlung wird bearbeitet, bitte Seite nicht verlassen'"></app-spinner>
  </div>

  <div *ngIf="!loading && !error" class="contents-wrapper">
    <div class="contents-container finapi">
      <noscript>
        <h2>Your browser does not support JavaScript.</h2>
        Please deactivate JavaScript Blocker, AdBlocker etc. to use the service.
      </noscript>
      <div id="webFormContainer"></div>
    </div>
  </div>
</div>
